// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9b3c62bc","453":"1a16ed4e","732":"185c3872","977":"c0cb4264"}[chunkId] + ".chunk.js";
};